/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Benefits_LinkInputs */

const en_directory_promotion_benefits_link = /** @type {(inputs: Directory_Promotion_Benefits_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product card and outbound link`)
};

const zh_directory_promotion_benefits_link = /** @type {(inputs: Directory_Promotion_Benefits_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品卡片与外部链接`)
};

/**
* | output |
* | --- |
* | "Product card and outbound link" |
*
* @param {Directory_Promotion_Benefits_LinkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_benefits_link = /** @type {((inputs?: Directory_Promotion_Benefits_LinkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Benefits_LinkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_benefits_link(inputs)
	return zh_directory_promotion_benefits_link(inputs)
});
export { directory_promotion_benefits_link as "directory.promotion.benefits.link" }